import { PDFDownloadLink } from '@react-pdf/renderer';
import { BRAND_NAME } from '../../../theme/brand';
import React, { useEffect, useRef, useState } from 'react'
import NotificationCertificatePDF from './ReportPdf';
import GoBack from '../../../components/GoBackButton';
import moment from 'moment';
import { LOGO_SRC as logo } from '../../../theme/brand';
import eocean from '../../../images/eocean.png';

import 'moment-timezone';
import { fetchWrapper } from '../../../helpers';

const Report = ({ data }) => {
    const contentRef = useRef();
    const [channelData, setchannelData] = useState([]);
    const [statusData, setstatusDataa] = useState([]);


    const getUserTimeZone = () => {
        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
        return userTimeZone
    }


    useEffect(() => {
        LoadChannelList()
        LoadStatusList()

    }, [])
    const LoadChannelList = async () => {
        const url = `${process.env.REACT_APP_API_URL}/channel/list`;
        const data = await fetchWrapper.get(url)

        setchannelData(data.data);
    }
    const LoadStatusList = async () => {
        const url = `${process.env.REACT_APP_API_URL}/status/list`;
        const data = await fetchWrapper.get(url)

        setstatusDataa(data.data);
    }
    function transformHistoryData(jsonData) {
        return jsonData.map(item => {
            // Find status name from status_id
            const statusObj = statusData.find(status => status.id === item.status_id);
            const statusName = statusObj ? statusObj.name : `Unknown (${item.status_id})`;

            // Find channel name from channel_id
            const channelObj = item.channel_id ? channelData.find(channel => channel.id == item.channel_id) : null;
            const channelName = channelObj ? channelObj.name : null;

            // Format the datetime
            const datetime = item?.time;


            return {
                status: statusName,
                channel: channelName,
                datetime: datetime,
                color: statusObj?.color,
            };
        });
    }


    const history = transformHistoryData(data?.history);


    return (
        <div style={{ width: "80%", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", margin: "auto", paddingTop: "50px" }}>
            <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                <GoBack />
                <PDFDownloadLink
                    document={<NotificationCertificatePDF history={history} data={data} />}
                    fileName="notification_certificate.pdf"
                    style={{ backgroundColor: "var(--brand-primary-hover)", color: "white", padding: "10px 20px", borderRadius: "5px", textDecoration: "none", fontSize: "16px" }}
                >
                    {({ blob, url, loading, error }) =>
                        loading ? 'Loading Document...' : 'Download PDF'
                    }
                </PDFDownloadLink>

            </div>


            <div className="certificate-container" ref={contentRef}>
                <div className="header">
                    <div className="logo-xnotify">
                        {/* Bounded box — logo aspect ratio is env-driven, see Header.js */}
                        <img src={logo} alt="Logo"
                            style={{ maxWidth: '120px', maxHeight: '60px', objectFit: 'contain' }} />
                    </div>
                    <div className="header-title">Notification Delivery Certificate</div>
                    <div className="logo-keen">
                        {/* <img src={`${process.env.REACT_APP_API_URL}${data.logo}`} alt="Keen Logo"
                            width="120px" /> */}
                    </div>
                </div>

                <div className="details-grid">
                    <div className='transcation_details'>
                        <div className="details-label">Transaction Reference No.</div>
                        <span className="details-values message_id">{data?.message_id}</span>
                    </div>

                    <div className="status">
                        <div className="details-label">Delivery Status: <span style={{ color: data?.Status?.color }}>{data?.Status?.name}</span></div>
                        <div > <span className="details-label">Delivery Time: </span>{moment.utc(data?.sent_date).tz(getUserTimeZone()).format('DD-MM-YY | hh:mm:ss A')}</div>
                    </div>
                </div>

                <div className="message-grid">
                    <div className="details">
                        <div className="details-label">Message Payload</div>
                        <div className="details-value message">{data?.message}
                        </div>
                    </div>
                    <div className="details">
                        <div className="details-label">System classification(s)</div>
                        <div className="details-value message">Secure - Time Sensitive - High Priority</div>
                    </div>
                </div>
                <h3 className='trace-route'>Trace Route</h3>

                <table>
                    <tbody>
                        {history.map((item, index) => (
                            <tr key={index}>
                                <td>{item.status}</td>
                                <td className="center-column">{item.channel || "-"}</td>
                                <td className="end-column">{moment(item.datetime).tz(getUserTimeZone()).format('DD-MM-YY hh:mm:ss A')}</td>
                            </tr>
                        ))}

                    </tbody>
                </table>

                <div className="no-signature">
                    <div className="no-signature-text">
                        This is a {BRAND_NAME} system generated report &
                        does not require a signature.
                    </div>

                </div>

                <div className="footer">
                    <div className="">
                        {/* <div>
                            <span className="footer-detail">Report ID:</span>
                            <span className="footer-value">EON-XN-KU-5515414753-2</span>
                        </div> */}
                        <div>
                            <span className="footer-detail">Generated on </span>
                            <span className="footer-value">{moment(data?.createdAt).tz(getUserTimeZone()).format('DD-MM-YY hh:mm:ss A')} </span>
                        </div>

                    </div>
                    <div className="header-title">
                        <img src={eocean} alt="Keen Logo"
                            width="180px" />
                    </div>

                </div>

            </div>
        </div>
    )
}

export default Report